import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { INK } from "../scanning/tokens";
import EmailReveal from "../../components/EmailReveal";
const Foot = styled.footer`
  background: ${INK}; padding: 48px 0 28px; color: #a7b4c8;
  h2 { font-size: 11px; letter-spacing: 1.2px; text-transform: uppercase; color: #fff; margin: 0 0 16px; }
  ul { list-style: none; padding: 0; margin: 0; } li { margin-bottom: 9px; }
  a { color: #a7b4c8; font-size: 13px; text-decoration: none; } a:hover { color: #fff; }
  .base { margin-top: 28px; padding-top: 22px; border-top: 1px solid #1e293b; font-size: 12px; }
`;
const columns = [
  ["Services", [["/how-mail-management-works/", "Mail scanning"], ["/parcel-forwarding-australia/", "Parcel forwarding"], ["/drop-shipping-australia/", "Drop shipping"], ["/document-scanning/", "Document scanning"]]],
  ["Costs", [["/pricing/", "Pricing"], ["/calculator/", "Mail calculator"], ["/parcel-forwarding-calculator/", "Forwarding estimator"]]],
  ["Resources", [["/blog/", "Blog"], ["/guides/", "Guides"], ["/faq/", "FAQs"]]],
  ["About", [["/contact-us/", "Contact us"], ["/about-hotsnail-mail-redirection/", "About HotSnail"], ["/terms-conditions/", "Terms"], ["/privacy/", "Privacy"]]],
];
export default function MailFooter() {
  return <Foot><Container><Row>{columns.map(([title, links]) => <Col xs="6" md="3" className="mb-4" key={title}><h2>{title}</h2><ul>{links.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>{title === "About" && <EmailReveal />}</Col>)}</Row><div className="base">© {new Date().getFullYear()} HotSnail. All rights reserved.</div></Container></Foot>;
}
